import { OpUnitType } from 'dayjs';

import { defineKey as T } from '@ha/intl';
import { RecurrenceType } from '@ha/api/v2/types/Subscriptions';

interface Info {
  isRenewable: boolean;
  duration: {
    number: number;
    unit: OpUnitType;
  };
  name: string;
  bulletPoints: string[];
}

export const PriceInfo: { [key in RecurrenceType]: Info } = {
  [RecurrenceType.Fortnightly]: {
    name: T('subscription.2_week_plan.name'),
    bulletPoints: [T('subscription.2_week_plan.bullet_2')],
    isRenewable: true,
    duration: {
      number: 14,
      unit: 'day',
    },
  },
  [RecurrenceType.Monthly]: {
    name: T('subscription.1_month_plan.name'),
    bulletPoints: [T('subscription.1_month_plan.bullet_2')],
    isRenewable: true,
    duration: {
      number: 1,
      unit: 'month',
    },
  },
  [RecurrenceType.OneOff]: {
    name: T('subscription.3_month_plan.name'),
    bulletPoints: [T('subscription.3_month_plan.bullet_2')],
    isRenewable: false,
    duration: {
      number: 3,
      unit: 'month',
    },
  },
};

export const PriceInfoPaymentRequest: { [key in RecurrenceType]: Info } = {
  [RecurrenceType.Monthly]: {
    name: T('account.subscription_type.payments_title'),
    bulletPoints: [T('subscription.1_month_plan.bullet_2')],
    isRenewable: true,
    duration: {
      number: 1,
      unit: 'month',
    },
  },
  [RecurrenceType.Fortnightly]: {
    name: T('subscription.2_week_plan.name'),
    bulletPoints: [T('subscription.2_week_plan.bullet_2')],
    isRenewable: true,
    duration: {
      number: 14,
      unit: 'day',
    },
  },
  [RecurrenceType.OneOff]: {
    name: T('subscription.3_month_plan.name'),
    bulletPoints: [T('subscription.3_month_plan.bullet_2')],
    isRenewable: false,
    duration: {
      number: 3,
      unit: 'month',
    },
  },
};

export const SubscriptionFeeRuleName = 'NL subscriptions';
